var PasswordForgottenCtrl = function (gettextCatalog, AppUser, $state, Notification) {
  this._AppUser = AppUser;
  this._state = $state;
  this._Notification = Notification;
  this.gettextCatalog = gettextCatalog;
  this.credentials = {};
  this.hasErrors = false;
  this.formSubmitted = false;
};

PasswordForgottenCtrl.prototype.send = function() {
  var self = this;
  this
    ._AppUser
    .resetPassword(
      this.credentials,
      function () {
        self._Notification.success(self.gettextCatalog.getString('Eine E-Mail mit weiteren Informationen wurde an {{email}} gesendet.', {email: self.credentials.email}));
      },
      function () {
        self._Notification.error(self.gettextCatalog.getString('Passwort Reset fehlgeschlagen. Bitte wenden Sie sich an unseren Support.'));
      });
};

module.exports = PasswordForgottenCtrl;




// WEBPACK FOOTER //
// ./client/src/app/modules/login/PasswordForgottenCtrl.js